import NameCell from './NameCell';

export default NameCell;
